/* eslint-disable no-useless-concat */
import React, { useEffect, useState } from 'react'
import TextField from "@material-ui/core/TextField";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import { allCreatedTest, reset, sendEmail } from '../../features/Test/testSlice';
import { useAppDispatch, useAppSelector } from '../../useStore';
import swal from "sweetalert";
import { baseUrl } from '../../shared/baseUrl';
import { Spinners } from '../TableOptions';
import ModalHeader from '../ModalHeader';

const InterviewModals = ({ nametitle, name, email }: any) => {
	const dispatch = useAppDispatch();
	const { allCreatedTestdata, allCreatedTestisError, allCreatedTestmessage } = useAppSelector((state: { test: any; }) => state.test)
	const { sendEmailisError, sendEmailmessage, sendEmailisSuccess, sendEmailisLoading } = useAppSelector((state: { test: any; }) => state.test)

	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	useEffect(() => {
		if (show) {
			dispatch(allCreatedTest());
		}
	}, [dispatch])

	useEffect(() => {
		if (allCreatedTestisError) {
			swal({
				title: "error",
				text: allCreatedTestmessage,
				icon: "error"
			})
			dispatch(reset())
		} else if (sendEmailisSuccess) {
			swal({
				title: "success",
				text: "Test Invitation Sent Successfully",
				icon: "success"
			})
			setShow(false)
			dispatch(reset())
		} else if (sendEmailisError) {
			swal({
				title: "error",
				text: sendEmailmessage,
				icon: "error"
			})
			dispatch(reset())
		}

	}, [allCreatedTestisError, allCreatedTestmessage, dispatch, sendEmailisError, sendEmailisSuccess, sendEmailmessage])




	const [inputs, setInputs] = useState<any>({
		email: "",
		body: "",
		subject: "",
	});



	const handleOnChange = (input: string, value: any) => {
		setInputs((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
		setView(true)
	};

	const test = allCreatedTestdata?.data?.filter((obj: any) => {
		return obj?.testCode === inputs?.test
	})


	const [view, setView] = useState(false);

	const testbody: any = test?.map((item: any, index: any) => (
		"Hi " + name + " ,\n\n" +
		"You have been invited to take Test Assessment by Outcess Solutions.\n\n" +

		"Please click on below link to take the test.\n" + `Test Link: ${baseUrl}/testX27QF0rPxLljNoAq71sgROuRuJd0A40aApO_EALw_wcB=preview/${!item ? "" : item?.id}` + "\n\n" +
		"Best regards,\n" + "The Recruiting Team" + "\n" + "Outcess Solutions."
	));





	useEffect(() => {
		setInputs((prevState: any) => {
			return ({
				...prevState,
				email: email,
				subject: `Hello ${name} Outcess Solutions sent you a test`,
				body: testbody,
			});
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [email, name, setInputs, view]);

	const handleSendEmail = () => {
		// @ts-ignore 
		dispatch(sendEmail(inputs))
	}


	return (
		<>
			<div onClick={handleShow} className="view-Evaluating-status">
				SEND TEST
			</div>

			<Modal show={show} onHide={handleClose}>
				<ModalHeader setShow={setShow} headerTitle={"Send Test"} />
				<Modal.Body>
					<form>
						<div className="applicant-name">
							<h5>Applicant Name</h5>
							<p>{nametitle + " " + name} </p>
						</div>
						<br />
						<div className="reviewer-name">
							<h6>Select Test</h6>

							<select
								className="round"
								value={inputs?.test}
								onChange={(e) => handleOnChange("test", e.target.value)} >

								<option>Select Options</option>
								{allCreatedTestdata?.data?.map((item: any, i: any) => (
									<option key={i} value={item?.testCode}>
										{item?.testTitle}
									</option>
								))}
							</select>


							<div className="comment mt-4">
								<h6>Test Description</h6>

								<TextField
									id="outlined-multiline-static"
									multiline
									fullWidth
									type="text"
									minRows={4}
									variant="outlined"
									style={{ margin: "10px 0" }}
									value={inputs?.body}
									onChange={(e) => handleOnChange("body", e.target.value)}
								/>

							</div>
						</div>

					</form>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Cancel
					</Button>
					<Button id="primary" onClick={handleSendEmail}>
						{sendEmailisLoading ? <Spinners size={"sm"} /> : 'Send'}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default InterviewModals
